import { Feature, Polygon } from 'geojson';

import { LogisticZoneMap } from '~services/logisticsZones/types';
import { createFeature } from '~utils/geoJson';

export const getZonePolygonFeature = (
  zone: LogisticZoneMap,
): Feature<Polygon> | undefined => {
  if (!zone.geometryAreaJson) return undefined;

  const currentPolygon: Polygon = JSON.parse(zone.geometryAreaJson);

  return createFeature({
    geometry: currentPolygon,
    id: zone.zoneId,
    properties: {
      currentColor: zone.color,
      label: zone.code,
    },
  });
};
